import React, { useState } from 'react'
import PageHeader from '../../components/PageHeader/PageHeader'
import { Button, Form, Input, Select, Spin, message, notification } from 'antd'
import { useDispatch, useSelector } from 'react-redux';
import { ReadCookie } from '../../utils/readCookie';
import Loader from "react-loader-spinner";
import { Row as Brow, Col as Bcol } from "reactstrap";
import { getAmazonProductUpdateNew, updateAmazonProductUpdateNew } from '../../redux/actions/amazonProductInformation.action';
import "./AmazonProductUpdateNew.css"

const AmazonProductUpdateNew = () => {
    const [form] = Form.useForm();
    const { productUpdateNew } = useSelector((state) => state);
    const dispatch = useDispatch();
    const token = ReadCookie("token");
    const [loading, setLoading] = useState(false);
    const [updateloading, setUpdateLoading] = useState(false);


    const onFinish = async () => {
        setLoading(true);
        try {
            const values = await form.validateFields();

            // 🔹 Reset specific form fields before setting new values
            form.resetFields([
                "style",
                "amazonSKU",
                "amazon_description",
                "bullet_1",
                "bullet_2",
                "bullet_3",
                "bullet_4",
                "bullet_5",
                "fabric",
                "image_locator"
            ]);

            const res = await dispatch(getAmazonProductUpdateNew(token, values));

            const { success, message, data } = res?.payload || {};
            const attributes = data?.amazonAttributes?.attributes;

            // 🔹 Notification handling
            if (success && message) {
                notification.success({
                    message: "Success",
                    description: message,
                    placement: "topRight",
                    duration: 2,
                });
            } else if (message) {
                notification.error({
                    message: "Error",
                    description: message,
                    placement: "topRight",
                    duration: 2,
                });
            }

            // 🔹 Agar attributes empty ya missing ho → yahin stop
            if (!attributes || Object.keys(attributes).length === 0) {
                return;
            }

            // 🔹 Extract values with defaults (empty string agar missing ho)
            const styleValue = attributes?.style?.[0]?.value || "";
            const amazon_SKU = data?.children_skus?.[0]?.amazon_sku || "";
            const descriptionValue = attributes?.product_description?.[0]?.value || "";
            const bullet1 = attributes?.bullet_point?.[0]?.value || "";
            const bullet2 = attributes?.bullet_point?.[1]?.value || "";
            const bullet3 = attributes?.bullet_point?.[2]?.value || "";
            const bullet4 = attributes?.bullet_point?.[3]?.value || "";
            const bullet5 = attributes?.bullet_point?.[4]?.value || "";
            const fabricType = attributes?.fabric_type?.[0]?.value || "";
            const imageLocator = attributes?.main_product_image_locator?.[0]?.media_location || "";

            console.log("amazon_SKU", amazon_SKU)
            // 🔹 Set form values
            form.setFieldsValue({
                style: styleValue,
                amazonSKU: amazon_SKU,
                amazon_description: descriptionValue,
                bullet_1: bullet1,
                bullet_2: bullet2,
                bullet_3: bullet3,
                bullet_4: bullet4,
                bullet_5: bullet5,
                fabric: fabricType,
                image_locator: imageLocator
            });

        } catch (error) {
            console.error(error);
            notification.error({
                message: "Error",
                description: "Something went wrong while fetching the product.",
                placement: "topRight",
                duration: 2,
            });
        } finally {
            setLoading(false);
        }
    };





    const handleUpdate = async (AmazonSKUs) => {
        const AmazonSKUArray = AmazonSKUs
            ? AmazonSKUs.split(",").map(sku => sku.trim()).filter(Boolean)
            : [];
        console.log("first", AmazonSKUArray)

        if (!AmazonSKUArray.length) {
            notification.error({
                message: "Error",
                description: "No SKU found to update.",
            });
            return;
        }

        setUpdateLoading(true);

        try {
            const values = await form.validateFields();
            const bulletPoint = [];

            if (values.bullet_1) bulletPoint.push(values.bullet_1);
            if (values.bullet_2) bulletPoint.push(values.bullet_2);
            if (values.bullet_3) bulletPoint.push(values.bullet_3);
            if (values.bullet_4) bulletPoint.push(values.bullet_4);
            if (values.bullet_5) bulletPoint.push(values.bullet_5);
            const selectedValues = {
                storeKey: "ww",
                sku: AmazonSKUArray,
                ...(values.amazon_description && { description: values.amazon_description }),
                ...(bulletPoint && { bullet_point: bulletPoint }),
                ...(values.fabric && { fabric_type: values.fabric }),
                ...(values.image_locator && { main_product_image_locator: values.image_locator })
            };

            console.log("selectedValues", selectedValues)

            const res = await dispatch(updateAmazonProductUpdateNew(token, selectedValues));

            if (res?.payload?.success) {
                notification.success({
                    message: "Update Successful",
                    description: res?.payload.message,
                });
            } else {
                notification.error({
                    message: "Update Failed",
                    description: "Something went wrong while updating the product.",
                });
            }

            form.resetFields([
                "sku",
                "amazonSKU",
                "style",
                "amazon_description",
                "bullet_1",
                "bullet_2",
                "bullet_3",
                "bullet_4",
                "bullet_5",
                "fabric",
                "image_locator",
            ]);

        } catch (err) {
            notification.error({
                message: err.errorFields ? "Validation Failed" : "Error",
                description: err.errorFields
                    ? "Please check the form fields and try again."
                    : "An error occurred while updating the product.",
            });
        } finally {
            setUpdateLoading(false);
        }
    };




    return (
        <div className="styleContainer">
            <div className="styleBody h-100">
                <PageHeader
                    title={"Amazon Product Update"}
                    minimize={false}
                    check={false}
                />
                {loading ?
                    <div className='loaderDiv' >
                        <Loader
                            type="Grid"
                            color="#212121"
                            height={50}
                            width={50}
                        />
                    </div> :
                    null}

                <div className="bodyStyle">
                    <div className="row">
                        <div className="col" style={{ margin: 10 }}>
                            <Form
                                form={form}
                                name="control-hooks"
                                onFinish={onFinish}
                            >
                                <Brow>
                                    <Bcol md={12} xl={18} xxl={20} className="pbpx-10">
                                        <Brow className={"mb-1"}>
                                            <Bcol lg={10} xl={7} xxl={6}>
                                                <div className="firstSectionRo amazon-sku-input">
                                                    <Form.Item
                                                        name="sku"
                                                        label="SKU"
                                                        labelAlign="left"
                                                        labelCol={{ span: 5 }}
                                                        // wrapperCol={{ span: 10 }}
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: "Please Select SKU",
                                                            },
                                                        ]}
                                                    >
                                                        <Input
                                                            placeholder="Enter SKU"
                                                            size="medium"
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </Bcol>
                                            <Bcol lg={2} xl={5} xxl={3}>
                                                <Button
                                                    htmlType="submit"
                                                    className="submit-btn-btm m-0 amazon-product-uploader-generate-btn"
                                                    type="primary"
                                                >
                                                    Submit
                                                </Button>
                                            </Bcol>
                                        </Brow>
                                        <Brow className={"mb-1"}>
                                            <Bcol lg={10} xl={7} xxl={6}>
                                                <div className="firstSectionRo">
                                                    <Form.Item
                                                        name="style"
                                                        label="Style"
                                                        labelAlign="left"
                                                        labelCol={{ span: 5 }}
                                                    // wrapperCol={{ span: 9 }}
                                                    >
                                                        <Input disabled style={{
                                                            color: "#000",
                                                            backgroundColor: "#f5f5f5",
                                                            opacity: 1,
                                                        }} />
                                                    </Form.Item>
                                                </div>
                                            </Bcol>
                                        </Brow>
                                        <Brow className={"mb-1"}>
                                            <Bcol lg={10} xl={7} xxl={6}>
                                                <div className="firstSectionRo">
                                                    <Form.Item
                                                        name="amazonSKU"
                                                        label="Amazon SKU"
                                                        labelAlign="left"
                                                        labelCol={{ span: 5 }}
                                                    // wrapperCol={{ span: 9 }}
                                                    >
                                                        <Input.TextArea disabled style={{
                                                            color: "#000",
                                                            backgroundColor: "#f5f5f5",
                                                            opacity: 1,
                                                        }} />
                                                    </Form.Item>
                                                </div>
                                            </Bcol>
                                        </Brow>
                                        <Brow className={"mb-1"}>
                                            <Bcol lg={10} xl={7} xxl={6}>
                                                <div className="firstSectionRo">
                                                    <Form.Item
                                                        name="amazon_description"
                                                        label="Product Description:"
                                                        labelAlign="left"
                                                        labelCol={{ span: 5 }}
                                                    >
                                                        <Input.TextArea
                                                            size="medium"
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </Bcol>
                                        </Brow>
                                        <Brow className={"mb-1"}>
                                            <Bcol lg={10} xl={7} xxl={6}>
                                                <div className="firstSectionRo">
                                                    <Form.Item
                                                        name="bullet_1"
                                                        label="Bullet Point 1:"
                                                        labelAlign="left"
                                                        labelCol={{ span: 5 }}
                                                    >
                                                        <Input.TextArea
                                                            size="medium"
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </Bcol>
                                        </Brow>
                                        <Brow className={"mb-1"}>
                                            <Bcol lg={10} xl={7} xxl={6}>
                                                <div className="firstSectionRo">
                                                    <Form.Item
                                                        name="bullet_2"
                                                        label="Bullet Point 2:"
                                                        labelAlign="left"
                                                        labelCol={{ span: 5 }}
                                                    >
                                                        <Input.TextArea
                                                            size="medium"
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </Bcol>
                                        </Brow>
                                        <Brow className={"mb-1"}>
                                            <Bcol lg={10} xl={7} xxl={6}>
                                                <div className="firstSectionRo">
                                                    <Form.Item
                                                        name="bullet_3"
                                                        label="Bullet Point 3:"
                                                        labelAlign="left"
                                                        labelCol={{ span: 5 }}
                                                    >
                                                        <Input.TextArea
                                                            size="medium"
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </Bcol>
                                        </Brow>
                                        <Brow className={"mb-1"}>
                                            <Bcol lg={10} xl={7} xxl={6}>
                                                <div className="firstSectionRo">
                                                    <Form.Item
                                                        name="bullet_4"
                                                        label="Bullet Point 4:"
                                                        labelAlign="left"
                                                        labelCol={{ span: 5 }}
                                                    >
                                                        <Input.TextArea
                                                            size="medium"
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </Bcol>
                                        </Brow>
                                        <Brow className={"mb-1"}>
                                            <Bcol lg={10} xl={7} xxl={6}>
                                                <div className="firstSectionRo">
                                                    <Form.Item
                                                        name="bullet_5"
                                                        label="Bullet Point 5:"
                                                        labelAlign="left"
                                                        labelCol={{ span: 5 }}
                                                    >
                                                        <Input.TextArea
                                                            size="medium"
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </Bcol>
                                        </Brow>
                                        <Brow className={"mb-1"}>
                                            <Bcol lg={10} xl={7} xxl={6}>
                                                <div className="firstSectionRo">
                                                    <Form.Item
                                                        name="fabric"
                                                        label="Fabric:"
                                                        labelAlign="left"
                                                        labelCol={{ span: 5 }}
                                                    >
                                                        <Input
                                                            size="medium"
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </Bcol>
                                        </Brow>
                                        <Brow className={"mb-1"}>
                                            <Bcol lg={10} xl={7} xxl={6}>
                                                <div className="firstSectionRo">
                                                    <Form.Item
                                                        name="image_locator"
                                                        label="Main Product Image Locator:"
                                                        labelAlign="left"
                                                        // labelCol={{ span: 5 }}
                                                        labelCol={{
                                                            xs: { span: 24 },
                                                            sm: { span: 24 },
                                                            md: { span: 5 },
                                                            lg: { span: 5 },
                                                        }}
                                                    >
                                                        <Input
                                                            size="medium"
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </Bcol>
                                        </Brow>
                                        <Bcol lg={10} xl={7} xxl={6} className="row d-flex justify-content-end">
                                            <Button
                                                style={{ marginRight: "11px" }}
                                                className="submit-btn-btm m-0 amazon-product-uploader-generate-btn"
                                                onClick={() => handleUpdate(productUpdateNew?.payload?.data?.children_skus?.[0]?.amazon_sku)}
                                                type="primary"
                                                disabled={
                                                    updateloading || !form.getFieldValue("style") ||
                                                    productUpdateNew?.payload?.data?.amazonAttributes?.success !== true ||
                                                    !productUpdateNew?.payload?.data?.amazonAttributes?.attributes ||
                                                    Object.keys(
                                                        productUpdateNew?.payload?.data?.amazonAttributes?.attributes || {}
                                                    ).length === 0
                                                }
                                            >
                                                {updateloading ? (
                                                    <Spin size="small" className="customer_payment_ledger_btn_loader mr-1" />
                                                ) : (
                                                    'Update'
                                                )}
                                                {/* Update */}
                                            </Button>
                                        </Bcol>
                                    </Bcol>
                                </Brow>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AmazonProductUpdateNew